import {
  UserProfile,
  getEmptyUserProfile
} from 'reducers/userprofile/userprofileSlice'

export function saveUserProfileToSessionStorage(payload: UserProfile): void {
  const sessionStor = window.sessionStorage
  sessionStor.setItem('usrProfile-isActive', payload.isActive.toString())
  if (payload.givenName) {
    sessionStor.setItem('usrProfile-givenName', payload.givenName)
  } else {
    sessionStor.removeItem('usrProfile-givenName')
  }
  if (payload.middleName) {
    sessionStor.setItem('usrProfile-middleName', payload.middleName)
  } else {
    sessionStor.removeItem('usrProfile-middleName')
  }
  if (payload.suffix) {
    sessionStor.setItem('usrProfile-suffix', payload.suffix)
  } else {
    sessionStor.removeItem('usrProfile-suffix')
  }
  if (payload.familyName) {
    sessionStor.setItem('usrProfile-familyName', payload.familyName)
  } else {
    sessionStor.removeItem('usrProfile-familyName')
  }
  if (payload.homePhone) {
    sessionStor.setItem('usrProfile-homePhone', payload.homePhone)
  } else {
    sessionStor.removeItem('usrProfile-homePhone')
  }
  if (payload.mobilePhone) {
    sessionStor.setItem('usrProfile-mobilePhone', payload.mobilePhone)
  } else {
    sessionStor.removeItem('usrProfile-mobilePhone')
  }
  if (payload.workPhone) {
    sessionStor.setItem('usrProfile-workPhone', payload.workPhone)
  } else {
    sessionStor.removeItem('usrProfile-workPhone')
  }
  if (payload.emailAddress) {
    sessionStor.setItem('usrProfile-emailAddress', payload.emailAddress)
  } else {
    sessionStor.removeItem('usrProfile-emailAddress')
  }
  if (payload.street) {
    sessionStor.setItem('usrProfile-street', payload.street)
  } else {
    sessionStor.removeItem('usrProfile-street')
  }
  if (payload.zip) {
    sessionStor.setItem('usrProfile-zip', payload.zip)
  } else {
    sessionStor.removeItem('usrProfile-zip')
  }
  if (payload.city) {
    sessionStor.setItem('usrProfile-city', payload.city)
  } else {
    sessionStor.removeItem('usrProfile-city')
  }
  if (payload.state) {
    sessionStor.setItem('usrProfile-state', payload.state)
  } else {
    sessionStor.removeItem('usrProfile-state')
  }

  if (payload.contactType) {
    sessionStor.setItem(
      'usrProfile-contact-type',
      payload.contactType.toString()
    )
  } else {
    sessionStor.removeItem('usrProfile-contact-type')
  }
}

export function loadUserProfileFromSessionStorage(): UserProfile {
  const sessionStor = window.sessionStorage
  const userProfile = getEmptyUserProfile()
  userProfile.isActive = false
  const isActive = sessionStor.getItem('usrProfile-isActive')
  if (isActive) {
    userProfile.isActive = isActive === 'true'
  }
  const givenName = sessionStor.getItem('usrProfile-givenName')
  if (givenName) {
    userProfile.givenName = givenName
  }

  const middleName = sessionStor.getItem('usrProfile-middleName')
  if (middleName) {
    userProfile.middleName = middleName
  }

  const suffix = sessionStor.getItem('usrProfile-suffix')
  if (suffix) {
    userProfile.suffix = suffix
  }

  const familyName = sessionStor.getItem('usrProfile-familyName')
  if (familyName) {
    userProfile.familyName = familyName
  }

  const homePhone = sessionStor.getItem('usrProfile-homePhone')
  if (homePhone) {
    userProfile.homePhone = homePhone
  }

  const mobilePhone = sessionStor.getItem('usrProfile-mobilePhone')
  if (mobilePhone) {
    userProfile.mobilePhone = mobilePhone
  }

  const workPhone = sessionStor.getItem('usrProfile-workPhone')
  if (workPhone) {
    userProfile.workPhone = workPhone
  }

  const emailAddress = sessionStor.getItem('usrProfile-emailAddress')
  if (emailAddress) {
    userProfile.emailAddress = emailAddress
  }

  const street = sessionStor.getItem('usrProfile-street')
  if (street) {
    userProfile.street = street
  }

  const zip = sessionStor.getItem('usrProfile-zip')
  if (zip) {
    userProfile.zip = zip
  }

  const city = sessionStor.getItem('usrProfile-city')
  if (city) {
    userProfile.city = city
  }

  const state = sessionStor.getItem('usrProfile-state')
  if (state) {
    userProfile.state = state
  }

  const contactType = sessionStor.getItem('usrProfile-contact-type')
  if (contactType) {
    userProfile.contactType = parseInt(contactType)
  }

  return userProfile
}
